/**
 * Loading-screen tips. See docs/LOADING_SCREEN.md §5.
 *
 * Every line MUST be a true game rule — the loader is the game's best teaching
 * surface, so a wrong tip here is a real bug, not a copy nit. Numbers below come
 * from docs/GAME_DATA.md and prototype/index.html; if either changes, re-check.
 *
 * No explicit type annotation: `as const` then infers a tuple, so indexing is
 * known-good under noUncheckedIndexedAccess.
 */
export const LOADING_TIPS = [
  'Your axe level decides which material you can break. A weak axe just bounces off.',
  'Your lamp level decides how deep you can walk. Past the limit, the tunnel is black.',
  'Treasure rocks look almost identical — only faint golden veining gives them away.',
  'A brighter lamp makes those golden veins far easier to spot.',
  'Trash rocks never pay Shwe Kyat, but an ad doubles the coins.',
  'Shwe Kyat arrives only after a finished Reward Hub ad.',
  'You can withdraw once you hold 50.00 Shwe Kyat.',
  'Harder rock costs more swings but rolls a much better treasure chance.',
  'Loose Stone needs a Wood Axe. Shwe Stone needs the Shwe Axe.',
  'Deeper rocks pay more — every metre adds to the payout.',
  'A Divine Rock hides in roughly one rock out of five hundred.',
  'Supply caches sit every 50 metres and restore your stamina.',
  'Star Stone and Shwe Stone sometimes hide an Ancient Key.',
  'The Shwe Lamp removes the depth limit completely.',
  'Sell trash from your Bag — the rare junk is worth more.',
  'Walking and swinging both cost stamina. Surface to rest for free.',
  'Nobody has ever reached the bottom.',
] as const;

/** Picked once per load — a tip that changes mid-load is unreadable. */
export function randomTip(): string {
  const i = Math.floor(Math.random() * LOADING_TIPS.length);
  return LOADING_TIPS[i] ?? LOADING_TIPS[0];
}
